export class WFormData {

    constructor() {
        this.setValue = this.setValue.bind(this);
        this.getValue = this.getValue.bind(this);
        this.setAllValues = this.setAllValues.bind(this);
        this.getAllValues = this.getAllValues.bind(this);
        this.setBundle = this.setBundle.bind(this);
        this.getBundleValues = this.getBundleValues.bind(this);
        this.setLabelExtra = this.setLabelExtra.bind(this);
        this.getLabelExtra = this.getLabelExtra.bind(this);
    }

    private values: any = {};
    private bundle: any = {};
    private extras: any = {};

    hasKey(name: string): any {
        return this.values.hasOwnProperty(name);
    }

    setValue(name: string, value: any): void {
        this.values[name] = value;
    }

    getValue(name: string): any {
        return this.values[name];
    }

    getAllValues(): any {
        return this.values;
    }

    setAllValues(data: any): void {
        this.values = data;
    }

    overwriteAllValues(data: any): void {
        Object.keys(data).forEach((k: string) => {
            this.values[k] = data[k];
        });
    }

    setBundle(data: any): void {
        //  console.log('bundle data', data);
        this.bundle = data;
    }

    setBundleByKey(key: string, bundle: Array<any>): void {
        this.bundle[key] = bundle;
    }

    getBundleValues(name: string): any {
        // console.log('bundle values', name, this.bundle);
        return this.bundle && this.bundle[name] ? this.bundle[name] : null;
    }

    setLabelExtra(name: string, value: any): void {
        this.extras[name] = { label: value };
    }

    getLabelExtra(name: string): any {
        return (this.extras[name] || {}).label || null;
    }
}
